import { gallery } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function Gallery() {
  return (
    <section id="tuji" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <SectionHeading
          kicker="瓜田图鉴"
          title="看得见的瓜 · 今日现场图集"
          desc="秀场、片场、舞台与应援现场，一张图读懂今天最有画面感的热点。"
        />
        <div className="mb-9 flex items-center gap-2 text-xs text-foreground-500">
          <i className="ri-arrow-left-right-line h-4 w-4" />
          左右滑动浏览
        </div>
      </div>

      <div className="no-scrollbar -mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 md:-mx-6 md:px-6">
        {gallery.map((g) => (
          <figure
            key={g.id}
            className="group w-[72%] shrink-0 snap-start overflow-hidden rounded-2xl border border-background-200 bg-background-50 sm:w-[46%] lg:w-[24%]"
          >
            <div className="relative aspect-[4/5] w-full overflow-hidden">
              <img
                src={g.img}
                alt={`瓜田图鉴：${g.title}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-transparent to-transparent" />
              <figcaption className="absolute inset-x-0 bottom-0 p-4">
                <p className="text-xs text-accent-200">{g.note}</p>
                <p className="mt-1 font-heading text-base font-bold text-background-50">{g.title}</p>
              </figcaption>
              <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-background-50/80 text-foreground-800 backdrop-blur opacity-0 transition-opacity group-hover:opacity-100">
                <i className="ri-zoom-in-line h-4 w-4" />
              </span>
            </div>
          </figure>
        ))}
      </div>
    </section>
  );
}